import React, { useState } from "react"; 
import { TextInput, SimpleForm, NumberInput, useNotify, required } from "react-admin"; 
import { createReseller, uploadImage } from ".";

export function CreateReseller() {
  const notify = useNotify();
  const [adminUsername, setAdminUsername] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [adminFirstName, setAdminFirstName] = useState("");
  const [adminLastName, setAdminLastName] = useState("");
  const [coach, setCoach] = useState("");
  const [resellerBrandTitle, setResellerBrandTitle] = useState("");
  const [description, setDescription] = useState("");
  const [logo, setLogo] = useState("");
  const [logoFooter, setLogoFooter] = useState("");
  const [resellerBrandProductProductCode, setResellerBrandProductProductCode] = useState("NORMAL");
  const [resellerBrandProductTitle, setResellerBrandProductTitle] = useState("رژیم فیتاوا");
  const [resellerBrandProductPrice, setResellerBrandProductPrice] = useState(250000);
  const [resellerBrandProductMarketingCost, setResellerBrandProductMarketingCost] = useState(50000);
  const [walletAmount, setWalletAmount] = useState("");

  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [footerLogoFile, setFooterLogoFile] = useState<File | null>(null);

  const handleLogoSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setLogoFile(file);
    }
  };

  // const handleFooterLogoSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (file) {
  //     setFooterLogoFile(file);
  //   }
  // };

  const handleSubmit = async (e: any) => { 
    let uploadedLogoUrl = "";
    let uploadedFooterLogoUrl = "";

    if (logoFile) {
      try {
        uploadedLogoUrl = await uploadImage(logoFile);
      } catch (error) {
        notify("خطا در آپلود لوگو", { type: "error" });
        return;
      }
    }

    if (footerLogoFile) {
      try {
        uploadedFooterLogoUrl = await uploadImage(footerLogoFile);
      } catch (error) {
        notify("خطا در آپلود لوگو فوتر", { type: "error" });
        return;
      }
    }
 
    const formData: any = {
      adminUsername,
      adminPassword,
      adminFirstName,
      adminLastName, 
      resellerBrandTitle,
      resellerBrandProductTitle,
      resellerBrandProductPrice: Number(resellerBrandProductPrice), 
      resellerBrandProductMarketingCost: Number(resellerBrandProductMarketingCost),  
      resellerBrandProductProductCode,
      walletAmount: Number(walletAmount),
      resellerBrandProductDietCount: 1,
      resellerBrandProductWithMentor: false
    };

    if (logo || logoFooter || coach || description || resellerBrandTitle) {
      formData.resellerBrandConfig = {};
      
      if (logo) formData.resellerBrandConfig.logo = logo;
      if (logoFooter) formData.resellerBrandConfig.footerLogo = logoFooter;
      if (coach) formData.resellerBrandConfig.coach = coach;
      if (description) formData.resellerBrandConfig.description = description;
      if (resellerBrandTitle) formData.resellerBrandConfig.title = resellerBrandTitle;
    }

    try {
      const response = await createReseller(formData);  
      if (response.status === "200" && response.msg?.resellerId && response.msg?.resellerBrandProductId && response.msg?.resellerBrandId && response.msg?.adminId) {
        notify("مربی با موفقیت ایجاد شد!", { type: "success" });
      } else {
        notify("خطا در ایجاد مربی!", { type: "error" });
      }
    } catch (error) {
      notify("خطا در ارسال اطلاعات!", { type: "error" });
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <h2 style={{marginRight:'1rem'}}>ایجاد مربی</h2>
      <SimpleForm save={handleSubmit}>
        <TextInput 
          label="یوزرنیم" 
          source="adminUsername" 
          value={adminUsername} 
          onChange={(e: any) => setAdminUsername(e.target.value)} 
          validate={required("یوزرنیم الزامی است")}
        />
        <TextInput 
          label="پسورد" 
          source="adminPassword" 
          value={adminPassword} 
          onChange={(e: any) => setAdminPassword(e.target.value)} 
          validate={required("پسورد الزامی است")}
        />
        <TextInput 
          label="نام" 
          source="adminFirstName" 
          value={adminFirstName} 
          onChange={(e: any) => setAdminFirstName(e.target.value)} 
          validate={required("نام الزامی است")}
        />
        <TextInput 
          label="نام خانوادگی" 
          source="adminLastName" 
          value={adminLastName} 
          onChange={(e: any) => setAdminLastName(e.target.value)} 
          validate={required("نام خانوادگی الزامی است")}
        />

        {/* <div style={{ marginBottom: '1rem' }}>
          <label>آپلود لوگو</label>
          <input 
            type="file" 
            onChange={handleLogoSelect} 
          />
        </div> */}

        <TextInput 
          label="نام و نام خانوادگی مربی" 
          source="coach" 
          value={coach} 
          onChange={(e: any) => setCoach(e.target.value)} 
        />
        <TextInput 
          label="عنوان برند" 
          source="resellerBrandTitle" 
          value={resellerBrandTitle} 
          onChange={(e: any) => setResellerBrandTitle(e.target.value)}  
        />
        <TextInput 
          label="تگ لاین برند" 
          source="description" 
          value={description} 
          onChange={(e: any) => setDescription(e.target.value)}  
        />

        <TextInput 
          label="لوگو"
          source="logo" 
          value={logo} 
          onChange={(e: any) => setLogo(e.target.value)}  
        />

        <TextInput 
          label="لوگو فوتر" 
          source="logoFooter" 
          value={logoFooter} 
          onChange={(e: any) => setLogoFooter(e.target.value)}  
        />

        <TextInput 
          label="نوع رژیم" 
          source="resellerBrandProductProductCode" 
          value={resellerBrandProductProductCode} 
          onChange={(e: any) => setResellerBrandProductProductCode(e.target.value)} 
          defaultValue={"NORMAL"}
          validate={required("نوع رژیم الزامی است")}
        />

        <TextInput 
          label="عنوان محصول" 
          source="resellerBrandProductTitle" 
          value={resellerBrandProductTitle} 
          onChange={(e: any) => setResellerBrandProductTitle(e.target.value)} 
          defaultValue={"رژیم فیتاوا"}
          validate={required("عنوان محصول الزامی است")}
        />
        <NumberInput 
          label="قیمت محصول" 
          source="resellerBrandProductPrice" 
          value={resellerBrandProductPrice} 
          onChange={(e: any) => setResellerBrandProductPrice(e.target.value)} 
          defaultValue={250000}
          validate={required("قیمت محصول الزامی است")}
          min={0} 
        />
        <NumberInput 
          label="هزینه بازاریابی فیتاوا" 
          source="resellerBrandProductMarketingCost" 
          value={resellerBrandProductMarketingCost} 
          onChange={(e: any) => setResellerBrandProductMarketingCost(e.target.value)} 
          defaultValue={50000}
          validate={required(" هزینه بازاریابی فیتاوا الزامی است")}
          min={0} 
        />
        
        <NumberInput 
          label="میزان شارژ کیف پول" 
          source="walletAmount" 
          value={walletAmount} 
          onChange={(e: any) => setWalletAmount(e.target.value)} 
          min={0} 
        />
      </SimpleForm>
    </div>
  );
}
